import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Plus } from 'lucide-react';

const CATS = ['plumbing','electrical','general','cleaning','pest','hvac','landscaping','security','other'];

const Vendors = () => {
    const [rows, setRows] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const load = async () => {
        try { const r = await axios.get('/api/vendors'); setRows(r.data.vendors || []); }
        catch { toast.error('Failed'); }
    };
    useEffect(() => { load(); }, []);
    return (
        <div className="max-w-5xl mx-auto space-y-6">
            <div className="flex justify-between items-center">
                <div><h1 className="text-2xl font-bold">Vendors</h1>
                    <p className="text-gray-600">Contractors you dispatch maintenance work to.</p></div>
                <button onClick={() => setShowForm(true)} className="inline-flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg">
                    <Plus className="h-4 w-4" /> New vendor
                </button>
            </div>
            <div className="bg-white rounded-xl border">
                <table className="w-full text-sm">
                    <thead className="bg-gray-50 text-left"><tr>
                        <th className="p-3">Name</th><th className="p-3">Category</th><th className="p-3">Contact</th>
                        <th className="p-3">Phone</th><th className="p-3">KRA PIN</th><th className="p-3">Rate</th><th className="p-3">Active</th>
                    </tr></thead>
                    <tbody>{rows.length === 0 ? <tr><td colSpan={7} className="p-6 text-center text-gray-500">No vendors yet.</td></tr> :
                        rows.map(v => (
                            <tr key={v.id} className="border-t">
                                <td className="p-3">{v.name}</td>
                                <td className="p-3 capitalize">{v.category}</td>
                                <td className="p-3">{v.contact_person || '—'}</td>
                                <td className="p-3">{v.phone || '—'}</td>
                                <td className="p-3 font-mono text-xs">{v.kra_pin || '—'}</td>
                                <td className="p-3">{v.default_rate ? `KES ${v.default_rate}` : '—'}</td>
                                <td className="p-3">{v.is_active ? '✅' : '—'}</td>
                            </tr>
                        ))}</tbody>
                </table>
            </div>
            {showForm && <VendorForm onClose={() => setShowForm(false)} onDone={() => { setShowForm(false); load(); }} />}
        </div>
    );
};

const VendorForm = ({ onClose, onDone }) => {
    const [f, setF] = useState({ name:'', category:'general', contact_person:'', phone:'', email:'', kra_pin:'', default_rate:'', notes:'' });
    const submit = async e => {
        e.preventDefault();
        try { await axios.post('/api/vendors', f); toast.success('Added'); onDone(); }
        catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
    };
    return (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
            <form onSubmit={submit} className="bg-white rounded-xl max-w-md w-full">
                <div className="p-4 border-b flex justify-between"><h2 className="font-semibold">New vendor</h2><button type="button" onClick={onClose}>✕</button></div>
                <div className="p-4 space-y-2">
                    <input required placeholder="Business name" className="w-full border rounded-lg px-3 py-2" value={f.name} onChange={e => setF({...f, name:e.target.value})} />
                    <select className="w-full border rounded-lg px-3 py-2" value={f.category} onChange={e => setF({...f, category:e.target.value})}>
                        {CATS.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                    <input placeholder="Contact person" className="w-full border rounded-lg px-3 py-2" value={f.contact_person} onChange={e => setF({...f, contact_person:e.target.value})} />
                    <div className="grid grid-cols-2 gap-2">
                        <input placeholder="Phone" className="border rounded-lg px-3 py-2" value={f.phone} onChange={e => setF({...f, phone:e.target.value})} />
                        <input type="email" placeholder="Email" className="border rounded-lg px-3 py-2" value={f.email} onChange={e => setF({...f, email:e.target.value})} />
                    </div>
                    <div className="grid grid-cols-2 gap-2">
                        <input placeholder="KRA PIN" className="border rounded-lg px-3 py-2" value={f.kra_pin} onChange={e => setF({...f, kra_pin:e.target.value})} />
                        <input type="number" step="0.01" placeholder="Default rate" className="border rounded-lg px-3 py-2" value={f.default_rate} onChange={e => setF({...f, default_rate:e.target.value})} />
                    </div>
                    <textarea rows={2} placeholder="Notes" className="w-full border rounded-lg px-3 py-2" value={f.notes} onChange={e => setF({...f, notes:e.target.value})} />
                </div>
                <div className="p-4 border-t flex justify-end gap-2">
                    <button type="button" onClick={onClose} className="px-4 py-2 border rounded-lg">Cancel</button>
                    <button className="px-4 py-2 bg-primary-600 text-white rounded-lg">Save</button>
                </div>
            </form>
        </div>
    );
};

export default Vendors;
